import type { PlanChangePlan, PlanChangeResult } from './types';

/** The engine writes a version's periodicity as Postgres interval text («1 mon», «1 year»). */
export const isAnnualPlan = (plan: PlanChangePlan) => /year|12 mon|365/.test(plan.periodicity);

export const perPeriodOf = (plan: PlanChangePlan) => (isAnnualPlan(plan) ? 'al año' : 'al mes');

const withPeriodicity = (plan: PlanChangePlan): PlanChangePlan => ({
	...plan,
	name: `${plan.name} ${isAnnualPlan(plan) ? 'anual' : 'mensual'}`,
});

/**
 * When the change moves between monthly and annual (phase 2, engine #318) both
 * plans carry the same product name, so every line of the screen names the
 * periodicity too. Within one periodicity the names stay as they are.
 */
export const labelPeriodicity = <T extends PlanChangeResult>(change: T): T =>
	change.periodicity_change && change.periodicity_change !== 'none'
		? { ...change, from: withPeriodicity(change.from), to: withPeriodicity(change.to) }
		: change;
